function getFlipForResize(initial, info) {
  return {
    flipX: info.scaleX < 0 !== initial.flipX,
    flipY: info.scaleY < 0 !== initial.flipY
  };
}
function getFlipMatrix(flip, width, height) {
  return {
    a: flip.flipX ? -1 : 1,
    b: 0,
    c: 0,
    d: flip.flipY ? -1 : 1,
    // mirroring around the center of the box: x' = width - x, y' = height - y
    e: flip.flipX ? width : 0,
    f: flip.flipY ? height : 0
  };
}
export {
  getFlipForResize,
  getFlipMatrix
};
//# sourceMappingURL=flip.mjs.map
